export default __webpack_public_path__ + "static/media/support_light.66498660.svg";